import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'src/app/shared/models/user.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserCreateModalService } from './user-create-modal.service';
import { Subscription } from 'rxjs';
import { Rol } from 'src/app/shared/models/rol.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-create-modal',
  templateUrl: './user-create-modal.component.html',
  styleUrls: ['./user-create-modal.component.scss']
})
export class UserCreateModalComponent implements OnInit, OnDestroy {

  userForm: FormGroup;
  @Input() user: User;
  isEdit: boolean;
  roles: Rol[];

  private rolesSubscription: Subscription = null;
  
  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private userCreateModalService: UserCreateModalService,
              private toastr: ToastrService) { }

  /**
   * OnInit
   */
  ngOnInit() {
    this.userForm = this.formBuilder.group({
      user_id  : [0],
      firstname: ['', [Validators.required, Validators.maxLength(50)]], updateOn: 'blur',
      lastname : ['', [                     Validators.maxLength(50)]],
      email    : ['', [Validators.required, Validators.email, Validators.maxLength(75)]],
      password : ['', [Validators.required, Validators.minLength(6)]],
      confirm  : ['', Validators.required],
      rol      : ['', Validators.required]
    }, {
      validator: MustMatch('password', 'confirm')
    });

    this.getRoles();

    if (this.user) {
      this.isEdit = true;
      this.userForm.removeControl('password');
      this.userForm.removeControl('confirm');

      this.userForm.patchValue({
        user_id  : this.user.user_id,
        firstname: this.user.firstname,
        lastname : this.user.lastname,
        email    : this.user.email,
        rol      : this.user.rol
      });

      this.userForm.updateValueAndValidity();
    }
  }

  /**
   * OnDestroy
   */
  ngOnDestroy(): void {
    if (this.rolesSubscription !== null) { this.rolesSubscription.unsubscribe(); }
  }

  /**
   * OnClose
   */
  close() {
    this.activeModal.close(
      this.userForm.value
    );
  }

  getRoles() {
    this.rolesSubscription = this.userCreateModalService.getRoles().subscribe((result: Rol[]) => {
      this.roles = result;
    }, (error) => {
      this.toastr.info(error.message);
      console.error(error.message);
    });
  }

  compareFn(c1: Rol, c2:Rol): boolean {     
    return c1 && c2 ? c1.rol_id === c2.rol_id : c1 === c2; 
  }
}

// Custom password validation
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      // Si los controles no son visibles no se realiza la validación
      if (control === undefined && matchingControl === undefined) {
        return;
      }

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
          // return if another validator has already found an error on the matchingControl
          return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
          matchingControl.setErrors({ mustMatch: true });
      } else {
          matchingControl.setErrors(null);
      }
  }
}